"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const note_service_1 = require("./note.service");
const note_controller_1 = require("./note.controller");
const jwt_1 = require("@nestjs/jwt");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const note_repository_1 = require("./note.repository");
let NoteModule = class NoteModule {
};
exports.NoteModule = NoteModule;
exports.NoteModule = NoteModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                entities_1.Note,
                entities_1.Company,
                entities_1.Opportunity,
                entities_1.FileUpload,
                entities_1.OpportunityActivityMap,
                entities_1.NoteDocumentMap,
            ]),
            jwt_1.JwtModule,
        ],
        controllers: [note_controller_1.NoteController],
        providers: [
            note_service_1.NoteService,
            note_repository_1.NoteRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            entity_service_utils_1.EntityService,
        ],
        exports: [note_service_1.NoteService, note_repository_1.NoteRepository],
    })
], NoteModule);
